export const extractYoutubeVideoID = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regExp);
    if ( match && match[7].length == 11 ){
        return match[7];
    }
    return false;   
}

export const getDesktopNewsItemVideoThumbnail = (youtubeID) => `https://img.youtube.com/vi/${youtubeID}/sddefault.jpg`

export const getMobileNewsItemVideoThumbnail = (youtubeID) => `https://img.youtube.com/vi/${youtubeID}/default.jpg`

export const getFeaturedVideoThumbnail = (youtubeID) => `https://img.youtube.com/vi/${youtubeID}/maxresdefault.jpg`

export const dateSplit = (date) => {
    const dateItem = date.split(' ')[0];
    return dateItem
}

export const isFacebookApp = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}